import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Badge } from "@/components/ui/badge";
import { ClockCounterClockwiseIcon as ClockCounterClockwise, EyeIcon as Eye, DownloadSimpleIcon as DownloadSimple, CheckCircleIcon as CheckCircle, EnvelopeSimpleIcon as EnvelopeSimple, WarningCircleIcon as WarningCircle } from "@phosphor-icons/react";

const TIPO = {
  visualizzato_area_cliente: { label: "Visualizzato in area cliente", icon: Eye, tone: "text-slate-600" },
  pdf_scaricato: { label: "PDF scaricato", icon: DownloadSimple, tone: "text-slate-600" },
  accettato_online: { label: "Accettato online", icon: CheckCircle, tone: "text-green-600" },
  email_cliente_inviata: { label: "Email cliente inviata", icon: EnvelopeSimple, tone: "text-blue-600" },
  email_interna_inviata: { label: "Email interna inviata", icon: EnvelopeSimple, tone: "text-blue-600" },
  email_errore: { label: "Errore email", icon: WarningCircle, tone: "text-rose-600" },
};

const fmtDT = (iso) => { try { return new Date(iso).toLocaleString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }); } catch { return iso; } };

export function PreventivoEventiDialog({ open, onOpenChange, preventivo }) {
  const [eventi, setEventi] = useState([]);
  useEffect(() => {
    if (open && preventivo?.id) api.get(`/crm/preventivi/${preventivo.id}/eventi`).then(({ data }) => setEventi(data)).catch(() => setEventi([]));
  }, [open, preventivo]);
  if (!preventivo) return null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg max-h-[85vh] overflow-y-auto" data-testid="preventivo-eventi-dialog">
        <DialogHeader><DialogTitle className="font-heading flex items-center gap-2"><ClockCounterClockwise size={20} /> Storico preventivo {preventivo.numero_preventivo || ""}</DialogTitle></DialogHeader>
        <div className="grid grid-cols-3 gap-2 mb-4 text-sm">
          <div className="rounded-sm border border-border p-2"><div className="text-[11px] uppercase tracking-wider text-muted-foreground">Visibile cliente</div><Badge variant="outline" className={`rounded-sm mt-1 ${preventivo.visibile_area_cliente ? "bg-green-50 text-green-700 border-green-200" : "bg-secondary"}`}>{preventivo.visibile_area_cliente ? "Sì" : "No"}</Badge></div>
          <div className="rounded-sm border border-border p-2"><div className="text-[11px] uppercase tracking-wider text-muted-foreground">Accettabile online</div><Badge variant="outline" className={`rounded-sm mt-1 ${preventivo.accettabile_online ? "bg-green-50 text-green-700 border-green-200" : "bg-secondary"}`}>{preventivo.accettabile_online ? "Sì" : "No"}</Badge></div>
          <div className="rounded-sm border border-border p-2"><div className="text-[11px] uppercase tracking-wider text-muted-foreground">Data accettazione</div><div className="mt-1 tabular-nums text-xs">{preventivo.data_accettazione ? fmtDT(preventivo.data_accettazione) : "—"}</div></div>
        </div>
        <div className="space-y-2" data-testid="preventivo-eventi-list">
          {eventi.length === 0 ? <p className="text-sm text-muted-foreground py-6 text-center">Nessun evento registrato.</p>
            : eventi.map((e) => {
              const m = TIPO[e.tipo] || { label: e.tipo, icon: ClockCounterClockwise, tone: "text-muted-foreground" };
              const I = m.icon;
              return (
                <div key={e.id} className="flex items-start gap-3 border-b border-border pb-2" data-testid="preventivo-evento-row">
                  <I size={18} weight="bold" className={`mt-0.5 ${m.tone}`} />
                  <div className="flex-1 min-w-0">
                    <div className="text-sm font-medium">{m.label}</div>
                    <div className="text-xs text-muted-foreground">{e.descrizione}</div>
                    <div className="text-[11px] text-muted-foreground mt-0.5">{fmtDT(e.data)}{e.utente ? ` · ${e.utente}` : ""}{e.ip ? ` · IP ${e.ip}` : ""}</div>
                  </div>
                </div>
              );
            })}
        </div>
      </DialogContent>
    </Dialog>
  );
}
